<div class="{{type?'m0 webview box':''}}">
  <div class="component">
    <div *ngIf="!type" class="title-section">
      <p class="text-center-align font-18 navy-blue-color font-weight-400"> Subscriber Contact
        Information </p>
      <p class="text-center-align font-12 grey-color font-weight-200"> Your Contact information
        is used for billing and purchase a subscription. </p>
    </div>
    <div class="row">
      <p class="font-12 font-weight-400 {{type ? 'text-color' : 'red-color'}}">*Required field</p>
      <div class="col-sm-6" [formGroup]="subsForm">
        <div class="form-group" formGroupName="contactDetails">
          <label class="form-group {{type ? 'wv-text required-webview' : 'desktop-text required'}}">First Name</label>
          <input type="text"
            class="form-control {{type && isAcura ? 'wv-text AcuraPlaceholder' : ''}} {{type && !isAcura ? 'wv-text HondaPlaceholder' : ''}}"
            placeholder="Enter First Name" formControlName="first_name" [ngClass]="
                ((subsForm.get('contactDetails').get('first_name').touched ||
                subsForm.get('contactDetails').get('first_name').dirty) &&
                subsForm.get('contactDetails').get('first_name').hasError('required') ||
                subsForm.get('contactDetails').get('first_name').hasError('firstNotAlpha')
                  ? 'is-invalid'
                  : '') ||
                    (((subsForm.get('contactDetails').get('first_name').touched ||
                    subsForm.get('contactDetails').get('first_name').dirty) &&
                      !subsForm.get('contactDetails').get('first_name').invalid)
                  ? 'is-valid'
                  : '')
              " />
          <div class="invalid-feedback">
            {{
            subsForm.get('contactDetails').get("first_name").hasError("required")
            ? "First Name is required"
            : ""
            }}
            {{
            subsForm.get('contactDetails').get("first_name").hasError("firstNotAlpha")
            ? "Enter valid First Name"
            : ""
            }}
          </div>
        </div>
      </div>
      <div class="col-sm-6" [formGroup]="subsForm">
        <div class="form-group" formGroupName="contactDetails">
          <label class="form-group {{type ? 'wv-text required-webview' : 'desktop-text required'}}">Last Name</label>
          <!-- <input type="text" placeholder="Enter Last Name" class="form-control" formControlName="last_name" required />-->
          <input type="text" placeholder="Enter Last Name"
            class="form-control {{type && isAcura ? 'wv-text AcuraPlaceholder' : ''}} {{type && !isAcura ? 'wv-text HondaPlaceholder' : ''}}"
            formControlName="last_name" [ngClass]="
                ((subsForm.get('contactDetails').get('last_name').touched ||
                subsForm.get('contactDetails').get('last_name').dirty) &&
                subsForm.get('contactDetails').get('last_name').hasError('required') ||
                subsForm.get('contactDetails').get('last_name').hasError('lastNotAlpha')
                  ? 'is-invalid'
                  : '') ||
                    (((subsForm.get('contactDetails').get('last_name').touched ||
                    subsForm.get('contactDetails').get('last_name').dirty) &&
                      !subsForm.get('contactDetails').get('last_name').invalid)
                  ? 'is-valid'
                  : '')
              " />
          <div class="invalid-feedback">
            {{
            subsForm.get('contactDetails').get("last_name").hasError("required")
            ? "Last Name is required"
            : ""
            }}
            {{
            subsForm.get('contactDetails').get("last_name").hasError("lastNotAlpha")
            ? "Enter valid Last Name"
            : ""
            }}
          </div>
        </div>
      </div>

      <div class="col-sm-6" [formGroup]="subsForm">
        <div class="form-group" formGroupName="contactDetails">
          <label class="form-group {{type ? 'wv-text required-webview' : 'desktop-text required'}}">Primary Phone
            Number</label>
          <!--<input type="text" class="form-control" placeholder="Enter Primary Phone Number" formControlName="phone"
            required />-->
          <input type="text"
            class="form-control {{type && isAcura ? 'wv-text AcuraPlaceholder' : ''}} {{type && !isAcura ? 'wv-text HondaPlaceholder' : ''}}"
            placeholder="Enter Primary Phone Number" formControlName="phone" appMaskPhone maxlength="14" [ngClass]="
              ((subsForm.get('contactDetails').get('phone').touched ||
              subsForm.get('contactDetails').get('phone').dirty) &&
              subsForm.get('contactDetails').get('phone').hasError('required') ||
              subsForm.get('contactDetails').get('phone').hasError('primaryNotValid')
              ||
              subsForm.get('contactDetails').get('phone').hasError('notMinLength')
                ? 'is-invalid'
                : '') ||
                  (((subsForm.get('contactDetails').get('phone').touched ||
                  subsForm.get('contactDetails').get('phone').dirty) &&
                    !subsForm.get('contactDetails').get('phone').invalid)
                ? 'is-valid'
                : '')
            " />
          <div class="invalid-feedback">
            {{
            subsForm.get('contactDetails').get("phone").hasError("required")
            ? "Phone number is required"
            : ""
            }}
            {{
            subsForm.get('contactDetails').get("phone").hasError("primaryNotValid")
            ? "Special characters are not allowed in phone number"
            : ""
            }}
            {{
            subsForm.get('contactDetails').get('phone').hasError('notMinLength')
            ? "Phone number should have atleast 10 digits"
            : ""
            }}
          </div>
        </div>
      </div>
      <div class="col-sm-6" [formGroup]="subsForm">
        <div class="form-group" formGroupName="contactDetails">
          <label class="form-group {{type ? 'wv-text' : 'desktop-text'}}">Mobile</label>
          <select
            class="form-select {{type && isAcura ? 'wv-text AcuraDropdown' : ''}} {{type && !isAcura ? 'wv-text HondaDropdown' : ''}}"
            formControlName="mobile_prov">
            <option *ngFor="let type of phoneTypes; trackBy: trackByNgForItem">
              {{ type.value }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-sm-6" [formGroup]="subsForm">
        <div class="form-group" formGroupName="contactDetails">
          <label class="form-group {{type ? 'wv-text' : 'desktop-text'}}">Secondary Phone Number (Optional)</label>
          <input type="text" placeholder="Enter Secondary Phone Number (Optional)"
            class="form-control {{type && isAcura ? 'wv-text AcuraPlaceholder' : ''}} {{type && !isAcura ? 'wv-text HondaPlaceholder' : ''}}"
            formControlName="cell_phone" appMaskPhone maxlength="14" [ngClass]="((subsForm.get('contactDetails').get('phone').touched ||
            subsForm.get('contactDetails').get('cell_phone').dirty) &&
            subsForm.get('contactDetails').get('cell_phone').hasError('secondaryNotValid')
            ||
            subsForm.get('contactDetails').get('cell_phone').hasError('notSecMinLength')
              ? 'is-invalid'
              : '') ||
                (((subsForm.get('contactDetails').get('cell_phone').touched ||
                subsForm.get('contactDetails').get('cell_phone').dirty) &&
                  !subsForm.get('contactDetails').get('cell_phone').invalid)
              ? 'is-valid'
              : '')
             " />
          <div class="invalid-feedback">
            {{
            subsForm.get('contactDetails').get("cell_phone").hasError("secondaryNotValid")
            ? "Special characters are not allowed in phone no"
            : ""
            }}
            {{
            subsForm.get('contactDetails').get('cell_phone').hasError('notSecMinLength')
            ? "Phone number should have atleast 10 digits"
            : ""
            }}
          </div>
        </div>
      </div>
      <div class="col-sm-6" [formGroup]="subsForm">
        <div class="form-group" formGroupName="contactDetails">
          <label class="form-group {{type ? 'wv-text' : 'desktop-text'}}">Country</label>
          <select
            class="form-select {{type && isAcura ? 'wv-text AcuraDropdown' : ''}} {{type && !isAcura ? 'wv-text HondaDropdown' : ''}}"
            formControlName="country_cd" (change)="onCountryChange($event)">
            <option *ngFor="let contoury of countries; trackBy: trackByNgForItem" [value]="contoury.value">
              {{ contoury.displayValue }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-sm-6" [formGroup]="subsForm">
        <div class="form-group" formGroupName="contactDetails">
          <label class="form-group {{type ? 'wv-text required-webview' : 'desktop-text required'}}">Email</label>
          <input type="text" placeholder="Enter Email"
            class="form-control {{type && isAcura ? 'wv-text AcuraPlaceholder' : ''}} {{type && !isAcura ? 'wv-text HondaPlaceholder' : ''}}"
            formControlName="email" [ngClass]="
                ((subsForm.get('contactDetails').get('email').touched ||
                subsForm.get('contactDetails').get('email').dirty) &&
                subsForm.get('contactDetails').get('email').hasError('required')
                   || subsForm.get('contactDetails').get('email').hasError('email')
                  ? 'is-invalid'
                  : '') ||
                    (((subsForm.get('contactDetails').get('email').touched ||
                    subsForm.get('contactDetails').get('email').dirty) &&
                      !subsForm.get('contactDetails').get('email').invalid)
                  ? 'is-valid'
                  : '')
              " required />
          <div class="invalid-feedback">
            {{
            subsForm.get('contactDetails').get("email").hasError("email")
            ? "Enter Valid Email"
            : ""
            }}
            {{
            subsForm.get('contactDetails').get("email").hasError("required")
            ? "Email is Required"
            : ""
            }}
          </div>
        </div>
      </div>
      <div class="col-sm-6" [formGroup]="subsForm">
        <div class="form-group" formGroupName="contactDetails">
          <label class="form-group {{type ? 'wv-text' : 'desktop-text'}}">Business Name (Optional)</label>
          <input type="text"
            class="form-control {{type && isAcura ? 'wv-text AcuraPlaceholder' : ''}} {{type && !isAcura ? 'wv-text HondaPlaceholder' : ''}}"
            placeholder="Enter Business Name (Optional)" formControlName="businessName" />
        </div>
      </div>
      <div class="col-sm-6" [formGroup]="subsForm">
        <div class="form-group" formGroupName="contactDetails">
          <label class="form-group {{type ? 'wv-text required-webview' : 'desktop-text required'}}">Preferred
            Language</label>

          <select
            class="form-select {{type && isAcura ? 'wv-text AcuraDropdown' : ''}} {{type && !isAcura ? 'wv-text HondaDropdown' : ''}}"
            formControlName="locale_name">
            <option *ngFor="let lan of preferredLanguage; trackBy: trackByNgForItem" [value]="lan.value">
              {{ lan.displayValue }}
            </option>
          </select>
        </div>
      </div>

      <div class="col-sm-6" [formGroup]="subsForm">
        <div class="form-group" formGroupName="contactDetails">
          <label class="form-group {{type ? 'wv-text required-webview' : 'desktop-text required'}}">
            Address Line 1
          </label>

          <input type="text"
            class="form-control {{type && isAcura ? 'wv-text AcuraPlaceholder' : ''}} {{type && !isAcura ? 'wv-text HondaPlaceholder' : ''}}"
            placeholder="Enter Address Line 1" formControlName="addressLine1" [ngClass]="
        (
          (subsForm.get('contactDetails').get('addressLine1').touched ||
           subsForm.get('contactDetails').get('addressLine1').dirty) &&
          (
            subsForm.get('contactDetails').get('addressLine1').hasError('required') ||
            subsForm.get('contactDetails').get('addressLine1').hasError('addressOnlySpace') ||
            subsForm.get('contactDetails').get('addressLine1').hasError('invalidAddress')
          )
        )
          ? 'is-invalid'
          : (
              (subsForm.get('contactDetails').get('addressLine1').touched ||
               subsForm.get('contactDetails').get('addressLine1').dirty) &&
              !subsForm.get('contactDetails').get('addressLine1').invalid
            )
          ? 'is-valid'
          : ''
      " />

          <div class="invalid-feedback">
            {{
            subsForm.get('contactDetails').get('addressLine1').hasError('required')
            ? 'Address is Required'
            : ''
            }}

            {{
            subsForm.get('contactDetails').get('addressLine1').hasError('addressOnlySpace') ||
            subsForm.get('contactDetails').get('addressLine1').hasError('invalidAddress')
            ? 'Enter a valid address'
            : ''
            }}
          </div>
        </div>
      </div>

      <div class="col-sm-6" [formGroup]="subsForm">
        <div class="form-group" formGroupName="contactDetails">
          <label class="form-group {{type ? 'wv-text' : 'desktop-text'}}">
            Address Line 2 (Optional)
          </label>

          <input type="text" placeholder="Apartment, Suite Unit, Building, Floor"
            class="form-control {{type && isAcura ? 'wv-text AcuraPlaceholder' : ''}} {{type && !isAcura ? 'wv-text HondaPlaceholder' : ''}}"
            formControlName="addressLine2" [ngClass]="
        (
          subsForm.get('contactDetails').get('addressLine2').value &&
          (subsForm.get('contactDetails').get('addressLine2').touched ||
           subsForm.get('contactDetails').get('addressLine2').dirty) &&
          (
            subsForm.get('contactDetails').get('addressLine2').hasError('addressOnlySpace') ||
            subsForm.get('contactDetails').get('addressLine2').hasError('invalidAddress')
          )
        )
          ? 'is-invalid'
          : (
              subsForm.get('contactDetails').get('addressLine2').value &&
              (subsForm.get('contactDetails').get('addressLine2').touched ||
               subsForm.get('contactDetails').get('addressLine2').dirty) &&
              !subsForm.get('contactDetails').get('addressLine2').invalid
            )
          ? 'is-valid'
          : ''
      " />

          <div class="invalid-feedback">
            {{
            subsForm.get('contactDetails').get('addressLine2').hasError('addressOnlySpace') ||
            subsForm.get('contactDetails').get('addressLine2').hasError('invalidAddress')
            ? 'Enter a valid address'
            : ''
            }}
          </div>
        </div>
      </div>

      <div class="col-sm-6" [formGroup]="subsForm">
        <div class="form-group" formGroupName="contactDetails">

          <label class="form-group {{type ? 'wv-text required-webview' : 'desktop-text required'}}">
            City
          </label>

          <input type="text"
            class="form-control {{type && isAcura ? 'wv-text AcuraPlaceholder' : ''}} {{type && !isAcura ? 'wv-text HondaPlaceholder' : ''}}"
            placeholder="Enter City" formControlName="city" [ngClass]="
        (
          (subsForm.get('contactDetails')?.get('city')?.touched ||
           subsForm.get('contactDetails')?.get('city')?.dirty) &&
          (
            subsForm.get('contactDetails')?.get('city')?.hasError('required') ||
            subsForm.get('contactDetails')?.get('city')?.hasError('cityOnlySpace') ||
            subsForm.get('contactDetails')?.get('city')?.hasError('invalidCity')
          )
        )
          ? 'is-invalid'
          : (
              (subsForm.get('contactDetails')?.get('city')?.touched ||
               subsForm.get('contactDetails')?.get('city')?.dirty) &&
              !subsForm.get('contactDetails')?.get('city')?.invalid
            )
          ? 'is-valid'
          : ''
      " />

          <div class="invalid-feedback">
            {{
            subsForm.get('contactDetails')?.get('city')?.hasError('required')
            ? 'City is Required'
            : ''
            }}

            {{
            subsForm.get('contactDetails')?.get('city')?.hasError('cityOnlySpace') ||
            subsForm.get('contactDetails')?.get('city')?.hasError('invalidCity')
            ? 'Enter a valid city name'
            : ''
            }}
          </div>

        </div>
      </div>

      <div class="col-sm-6" [formGroup]="subsForm">
        <div class="form-group" formGroupName="contactDetails">
          <label class="form-group {{type ? 'wv-text required-webview' : 'desktop-text required'}}">State /
            Province</label>
          <select
            class="form-select {{type && isAcura ? 'wv-text AcuraDropdown' : ''}} {{type && !isAcura ? 'wv-text HondaDropdown' : ''}}"
            formControlName="state_prov">
            <option disabled selected [value]="null" style="display:none">Select State</option>
            <option *ngFor="let state of stateProvDropdown; trackBy: trackByNgForItem" [value]="state.value">
              {{ state.displayValue }}
            </option>
          </select>
        </div>
      </div>
      <div class="col-sm-6" [formGroup]="subsForm">
        <div class="form-group" formGroupName="contactDetails">

          <label class="form-group {{type ? 'wv-text required-webview' : 'desktop-text required'}}">
            Zip Code
          </label>

          <input type="text"
            class="form-control {{type && isAcura ? 'wv-text AcuraPlaceholder' : ''}} {{type && !isAcura ? 'wv-text HondaPlaceholder' : ''}}"
            placeholder="Enter Zip" formControlName="postal_cd" [ngClass]="
        (
          (subsForm.get('contactDetails')?.get('postal_cd')?.touched ||
           subsForm.get('contactDetails')?.get('postal_cd')?.dirty) &&
          subsForm.get('contactDetails')?.get('postal_cd')?.invalid
        )
          ? 'is-invalid'
          : (
              (subsForm.get('contactDetails')?.get('postal_cd')?.touched ||
               subsForm.get('contactDetails')?.get('postal_cd')?.dirty) &&
              !subsForm.get('contactDetails')?.get('postal_cd')?.invalid
            )
              ? 'is-valid'
              : ''
      " />

          <div class="invalid-feedback">

            <div *ngIf="subsForm.get('contactDetails')?.get('postal_cd')?.hasError('required')">
              Zip Code is Required
            </div>

            <div *ngIf="subsForm.get('contactDetails')?.get('postal_cd')?.hasError('zipUSNotValid')">
              Enter a valid zip code (XXXXX or XXXXX-XXXX)
            </div>

            <div *ngIf="subsForm.get('contactDetails')?.get('postal_cd')?.hasError('zipCADNotValid')">
              Enter a valid zip code (A1A1A1)
            </div>

          </div>

        </div>
      </div>
    </div>
    <div class="private-policy">
      <p class="font-14 {{type? 'private-policy-text-wv':'private-policy-text'}} ">
        To learn more about how we collect and use personal information, please
        read our <a href="https://www.honda.com/privacy/privacy-notice" target="{{type ? '_self' : '_blank'}}">Privacy
          Notice</a>.
      </p>
    </div>
  </div>
</div>
<div *ngIf="!type" class="container-buttons">
  <button class="danger-btn" (click)="onCancel()" mat-button matStepperPrevious>Cancel</button>
  <button class="primar-btn" mat-button matStepperPrevious>Previous</button>
  <button mat-button class="primar-btn" matStepperNext (click)="contactInfoSubmitted()"
    [disabled]="subsForm.get('contactDetails').invalid">
    Next
  </button>
</div>

<div *ngIf="type" class="container-buttons-wv flex-column-wv">
  <button mat-button class="button-with-radius {{isAcura ? 'AcuraBtn-disabled' : 'HondaBtn-disabled'}}" matStepperNext
    [disabled]="subsForm.get('contactDetails').invalid" (click)="contactInfoSubmitted()">
    Next
  </button>
  <button class="button-wv" mat-button matStepperPrevious>
    Previous
  </button>
</div>